import { render, staticRenderFns } from "./LengthDisplay.vue?vue&type=template&id=c81fcc16&scoped=true&"
import script from "./LengthDisplay.vue?vue&type=script&lang=js&"
export * from "./LengthDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81fcc16",
  null
  
)

export default component.exports